var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14625",
    "data-name": "Group 14625",
    transform: "translate(-171.877 -132)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2829",
    "data-name": "Ellipse 2829",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(171.877 132)",
    fill: "#2da381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12713",
    "data-name": "Path 12713",
    d: "M135.065,167.9a.639.639,0,0,1-.456-.191l-2.359-2.4a.639.639,0,0,1,.912-.9l1.885,1.915,3.9-4.294a.639.639,0,1,1,.946.86l-4.354,4.795a.639.639,0,0,1-.46.21Z",
    transform: "translate(42.98 -26.04)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.aea18f2237536cf4ab49fee9fe4dde6f.svg";
export { ForwardRef as ReactComponent };